import { api } from '../api';
import type { User } from 'firebase/auth';
import { GuestService } from './guest';

export const signInWithEmail = (email: string, pass: string) => api.auth.signInWithEmail(email, pass);
export const linkWithEmail = (email: string, pass: string) => api.auth.linkWithEmail(email, pass);
export const logout = () => {
    GuestService.clearAll();
    return api.auth.logout();
};
export const subscribeToAuthChanges = (cb: (user: User | null) => void) => api.auth.subscribe(cb);
export const signUp = (email: string, pass: string) => api.auth.signUp(email, pass);
export const signInWithGoogle = () => api.auth.signInWithGoogle();
export const sendPasswordResetEmail = (email: string) => api.auth.sendPasswordResetEmail(email);
export const sendMagicLink = (email: string, redirectUrl: string) => api.auth.sendMagicLink(email, redirectUrl);
export const isMagicLink = (url: string) => api.auth.isMagicLink(url);
export const signInWithMagicLink = (email: string, url: string) => api.auth.signInWithMagicLink(email, url);
export const deleteAccount = (user: User) => api.auth.deleteAccount(user);
